import { VoiceFormValues } from '../typings'

export function useFormConfig(overrideValues: uui.domain.server.rm.VoiceConfig): VoiceFormValues {
  const initValues: VoiceFormValues = {
    status: 'OFF',
    forbidDriverCallsToCompletedOrderSteps: false,
    forbidDriverCallsToIncompleteOrderSteps: false,
    callbackConfigStatus: 'OFF',
    backOfficePhone: '',
    automatedMessageEnabled: 'OFF',
    automatedMessage: '',
    automatedMessageVoice: 'FEMALE',
  }

  initValues.status = overrideValues?.status

  if (overrideValues?.status === 'ADVANCED') {
    initValues.forbidDriverCallsToCompletedOrderSteps =
      overrideValues.forbidDriverCallsToCompletedOrderSteps
    initValues.forbidDriverCallsToIncompleteOrderSteps =
      overrideValues.forbidDriverCallsToIncompleteOrderSteps
    initValues.callbackConfigStatus = overrideValues.callbackConfig.status || 'BACK_OFFICE'

    if (overrideValues?.callbackConfig.status === 'BACK_OFFICE') {
      initValues.backOfficePhone = overrideValues.callbackConfig.backOfficePhone
    } else {
      initValues.automatedMessageEnabled = overrideValues.callbackConfig?.automatedMessageEnabled
        ? 'ON'
        : 'OFF'
      initValues.automatedMessage = overrideValues.callbackConfig?.automatedMessage || ''
      initValues.automatedMessageVoice =
        overrideValues.callbackConfig?.automatedMessageVoice || 'FEMALE'
    }
  }

  return initValues
}
